import { Box, Chip, Tooltip, Typography, useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { IconChip } from './PageSection/index';
import IconLibrary from './IconLibrary';

export const SLOT_TYPE_CHIP = {
  ALL_DAY: {
    bg: '#B2DFDB',
    fg: '#004D40',
    hover: '#80CBC4',
    text: 'All Day',
  },
  MORNING: { bg: '#BBDEFB', fg: '#0D47A1', hover: '#90CAF9', text: 'Morning' },
  AFTERNOON: {
    bg: '#FFE0B2',
    fg: '#BF360C',
    hover: '#FFCC80',
    text: 'Afternoon',
  },
  EVENING: {
    bg: '#E1BEE7',
    fg: '#4A148C',
    hover: '#CE93D8',
    text: 'Evening',
  },
};

export function getSlotChipSx({ slotKey, disabled = false, theme }) {
  const c = SLOT_TYPE_CHIP[slotKey] || SLOT_TYPE_CHIP.MORNING;
  if (disabled) {
    return {
      bgcolor: theme.palette.action.disabledBackground,
      color: theme.palette.text.disabled,
      '&:hover': {
        bgcolor: theme.palette.action.disabledBackground,
      },
    };
  }
  return {
    bgcolor: c.bg,
    color: c.fg,
    '&:hover': { bgcolor: c.hover },
  };
}

function CustomChipLabel({ name, type }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Typography component="span" variant="subtitle">
        {name}
      </Typography>
      {type === '+SS' && (
        <Tooltip
          arrow
          placement="top"
          title={
            <FormattedMessage
              id="THIS_SLOT_WAS_ADDED_BY_USER_ON_LIVE_CALENDAR"
              defaultMessage="This slot was added by user on live calendar"
            />
          }>
          <Box>
            <IconChip
              sx={{ pointerEvents: 'auto' }}
              size={15}
              iconFontSize={10}
              Icon={IconLibrary.SpecialSchedule}
              bgColor="primary.dark"
              iconColor="white"
            />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
}

function TimeSlotTypeChip({
  name,
  code,
  type = '',
  onClick = null,
  disabled = false,
}) {
  const theme = useTheme();
  return (
    <Chip
      {...(onClick && {
        onClick: e =>
          onClick(
            {
              name,
              code,
            },
            e,
          ),
      })}
      label={<CustomChipLabel name={name} type={type} />}
      size="small"
      variant="filled"
      sx={{
        ...getSlotChipSx({ slotKey: code, disabled, theme }),
        justifyContent: 'flex-start',
        '& .MuiChip-label': {
          width: '100%',
          textAlign: 'left',
        },
        minWidth: '80px',
      }}
    />
  );
}
export default TimeSlotTypeChip;
